import './style.scss';

export default class ProfileCePanel extends UIObject {
  mDiv: JQuery<HTMLElement>;
  timeCreated: number;
  mData: any;
  requiresBuilding: boolean;

  constructor() {
    super();
  }

  initialize(aConstructorParams: any) {
    this.requiresBuilding = true;
    this.mDiv = this._generateHtml();
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        id: 'juno_ce_dashboard',
      }),
    );
  }

  private _buildSettings(): void {
    if (this.requiresBuilding) {
      this.requiresBuilding = false;

      const routeKey = App.INSTANCE?.mPathObject.as;
      /*
      Leon doesn't know what this was for
      window.onpopstate = function (e) {
        // need to manually reload when back button is pressed to the initial state
        if (e.state.idx === 0) {
          location.reload();
        }
      };
      */

      this.timeCreated = Date.now();
      const defaultWidgetProps = App.INSTANCE.defaultVNextWidgetProps();
      this.mData = {
        // todo: pare down this config object to just a theme
        ...defaultWidgetProps,
        pageSlug: 'ce_tab',
        routeKey,
      };

      window.JunoWidgetSettings = window.JunoWidgetSettings || {};
      window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
      window.JunoWidgetSettings.widgets.push({
        siteId: CrowdHub_App.CONFIG.VNEXT_SITE_ID,
        widget: 'juno_ce_dashboard',
        mount: 'juno_ce_dashboard',
        data: this.mData,
        timeCreated: this.timeCreated,
      });

      const newScript = document.createElement('script');
      newScript.src = CrowdHub_App.CONFIG.VNEXT_WIDGET_SCRIPT_SRC || `https://widgets.junolive.dev/junoWidgets.js`;
      this.mDiv.append(newScript);
    }
  }

  onTransitionIn(): void {
    this._buildSettings();
  }

  destroy(): void {
    const widgetKey = 'juno_ce_dashboard';
    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    const matchesWidget = widget => widget.widget === widgetKey && widget.timeCreated === this.timeCreated;
    const selectedWidget = window.JunoWidgetSettings.widgets.find(widget => matchesWidget(widget));
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets.filter(widget => !matchesWidget(widget));
    selectedWidget?.reactRoot?.unmount();
  }
}
